import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DatasetLinkedRoundedIcon from '@mui/icons-material/DatasetLinkedRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import SavingsRoundedIcon from '@mui/icons-material/SavingsRounded';
import TravelExploreRoundedIcon from '@mui/icons-material/TravelExploreRounded';
import ScreenSearchDesktopRoundedIcon from '@mui/icons-material/ScreenSearchDesktopRounded';

const items = [
  {
    icon: <TravelExploreRoundedIcon />,
    title: 'Scan momentum quickly',
    description:
      'Use market flow and trending lists to spot where attention is moving before you switch into a chart.',
  },
  {
    icon: <TuneRoundedIcon />,
    title: 'Switch presets in context',
    description:
      'Indicator chips let you change setup logic without leaving the main workspace or rebuilding your view.',
  },
  {
    icon: <DatasetLinkedRoundedIcon />,
    title: 'Connect signal to execution',
    description:
      'Charts, indicators, and order flow sit side by side so strategy decisions stay grounded in live context.',
  },
  {
    icon: <ScreenSearchDesktopRoundedIcon />,
    title: 'Review the market in one pass',
    description:
      'The interface is dense in the right way: relevant data is surfaced, template fluff is gone.',
  },
  {
    icon: <NotificationsRoundedIcon />,
    title: 'React without babysitting',
    description:
      'Push notifications keep you informed of entries, exits, and profit-taking even when you are off the dashboard.',
  },
  {
    icon: <SavingsRoundedIcon />,
    title: 'Secure gains into stablecoins',
    description:
      'Profit-focused workflows help you lock in outcomes instead of watching wins evaporate in volatility.',
  },
];

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        py: { xs: 8, sm: 12 },
      }}
    >
      <Container>
        <Stack spacing={2} sx={{ maxWidth: 760, mb: 4.5 }}>
          <Typography
            variant="caption"
            sx={{ color: 'primary.light', letterSpacing: 2, textTransform: 'uppercase' }}
          >
            Workflow
          </Typography>
          <Typography component="h2" variant="h2">
            Built for traders who want speed, context, and fewer blind spots.
          </Typography>
        
        </Stack>
        <Grid container spacing={2}>
          {items.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.title}>
              <Card
                variant="outlined"
                sx={{
                  p: 3,
                  height: '100%',
                  borderRadius: '24px',
                  borderColor: 'divider',
                  bgcolor: 'rgba(255,255,255,0.03)',
                }}
              >
                <Box sx={{ color: 'primary.light', mb: 1.5 }}>{item.icon}</Box>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  {item.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.description}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
